enum Status {
  ACTIVE = "active",
  IN_ACTIVE = "in_active",
  PENDING = "pending",
  APPROVED = "approved",
  APPROVE = "approve",
  REJECT = "reject",
}

export default Status;
